import type { RouteRecordRaw } from "vue-router";

export const fileSharingRoutes: RouteRecordRaw[] = [
  {
    path: "/file_sharing/info",
    name: "file_sharing-info",
    component: () => import("./info.vue"),
    meta: {
      namespace: "file_sharing",
      title: "tools_meta.file_sharing_prefix",
    },
  },
  {
    path: "/file_sharing/files",
    name: "file_sharing-index",
    component: () => import("./files/SharedFileListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "file_sharing",
      title: "tools_meta.file_sharing_prefix",
    },
  },
  {
    path: "/file_sharing/files/:id",
    name: "file_sharing-show",
    component: () => import("./files/SharedFileLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "file_sharing",
      title: "tools_meta.file_sharing_prefix",
    },
    children: [
      {
        path: "settings",
        name: "file_sharing-settings",
        component: () => import("./files/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "file_sharing",
          title: "tools_meta.file_sharing_prefix",
        },
      },
      {
        path: "share",
        name: "file_sharing-share",
        component: () => import("./files/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "file_sharing",
          title: "tools_meta.file_sharing_prefix",
        },
      },
    ],
  },
  {
    path: "/file_sharing/public_files/:id",
    name: "file_sharing-public-show",
    component: () => import("./public_files/PublicSharedFilePage.vue"),
    meta: {
      namespace: "file_sharing",
      title: "tools_meta.file_sharing_prefix",
    },
  },
];
